/**
 * useMediaAssetById – fetch a single media_asset by UUID.
 * Returns resolved URLs (320/640) for public-media assets.
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { resolveAssetUrl } from '@/lib/media/mediaApi';
import type { MediaAsset } from '@/lib/media/mediaTypes';

export function useMediaAssetById(id: string | null | undefined) {
  const { data: asset = null, isLoading } = useQuery({
    queryKey: ['media-asset', id],
    enabled: !!id,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('media_assets')
        .select('*')
        .eq('id', id!)
        .maybeSingle();
      if (error) throw error;
      return (data as unknown as MediaAsset) ?? null;
    },
    staleTime: 5 * 60_000,
  });

  return {
    asset,
    url320: asset ? resolveAssetUrl(asset, 320) : null,
    url640: asset ? resolveAssetUrl(asset, 640) : null,
    isLoading,
  };
}
